var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-tel-input',{attrs:{"value":_vm.phoneNumber,"disabled":_vm.disabled,"onlyCountries":_vm.allowedCountries},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }